<app-main-slider></app-main-slider>
<div
  [ngStyle]="{ 'background-image': identity.pattern ? 'url(' + identity.pattern + ')' : null }"
  style="background-size: 100%"
>
  <div *ngFor="let component of componentSequence">
    <div [ngSwitch]="component.type">
      <div *ngIf="showSection(homeSections.LiveCourses)">
        <app-live-courses
          *ngSwitchCase="0"
          [courseTypeSectionsStatus]="courseTypeSectionsStatus"
        ></app-live-courses>
      </div>
      <div *ngIf="showSection(homeSections.RecordedCourses)">
        <app-recorded-courses
          *ngSwitchCase="1"
          [courseTypeSectionsStatus]="courseTypeSectionsStatus"
        ></app-recorded-courses>
      </div>
      <div *ngIf="showSection(homeSections.LearningPaths)">
        <app-training-tracks
          *ngSwitchCase="2"
          [title]="getDetails(homeSections.LearningPaths).title"
          [description]="getDetails(homeSections.LearningPaths).description"
        ></app-training-tracks>
      </div>
      <div *ngIf="showSection(homeSections.Statistics)">
        <app-counter *ngSwitchCase="8"></app-counter>
      </div>
      <div *ngIf="showSection(homeSections.Partners)">
        <app-partners *ngSwitchCase="4"></app-partners>
      </div>
      <div *ngIf="showSection(homeSections.TrainingCenters)">
        <app-training-centers *ngSwitchCase="6"></app-training-centers>
      </div>
      <div *ngIf="showSection(homeSections.MiddleBanner)">
        <app-middle-banner
          *ngSwitchCase="3"
          [section]="getDetails(homeSections.MiddleBanner)"
        ></app-middle-banner>
      </div>
      <div *ngIf="showSection(homeSections.Testimonials)">
        <app-testimonials *ngSwitchCase="5"></app-testimonials>
      </div>
      <div *ngIf="showSection(homeSections.Instructors)">
        <app-instructors *ngSwitchCase="11"></app-instructors>
      </div>
      <div *ngIf="showSection(homeSections.Advertisements)">
        <app-advertisements *ngSwitchCase="12"></app-advertisements>
      </div>
    </div>
  </div>
</div>
